// extracted by mini-css-extract-plugin
export var actions = "bz_d3";
export var content = "bz_Y";
export var headline = "bz_d2";
export var imageContainer = "bz_bC";
export var singleCtaContainer = "bz_d0";
export var variant = "bz_d1";
export var wrapper = "bz_bM";